import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { useUserStore } from '@roc/feature-app-core';
import { useLoanStore } from '@roc/feature-loans';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { ManualQuoteTab } from 'libs/feature-loan-details/src/loanDetails/tabs/manualQuoteTab';
import { useStore } from '@roc/client-portal-shared/hooks';

export interface PricingTermLoanDialogProps {
  open: boolean;
  onClose: () => void;
  document: any;
}

export const ManualQuoteLoanDialog = observer((props: PricingTermLoanDialogProps) => {
  const { open, onClose, document } = props;
  const taskId = document?.taskId;
  const { globalStore } = useStore();
  const { loanStore } = useLoanStore();
  const { userStore } = useUserStore();
  const { loanId } = useParams<{ loanId: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const numericLoanId = Number(loanId);
  const [isLoadingUser, setIsLoadingUser] = useState(false);


  const fetchLoanDetails = async () => {
    if (!numericLoanId) return;
    setIsLoading(true);
    await loanStore.fetchLoanDetails(numericLoanId, () => {
      setIsLoading(false);
    });

    setIsLoadingUser(true);
    userStore.getUserInfoAndEntitlements(() => {
      globalStore.lenderInfo = {
        ...globalStore.lenderInfo,
        lenderId: loanStore.loanDetails.lenderId,
        isInternal: loanStore.loanDetails?.manualQuoteLoanDetailValues?.internalLender
      }
      setIsLoadingUser(false)
    });
  };

  useEffect(() => {
    if (!numericLoanId) return;
    if (loanStore?.loanDetails?.loanId !== numericLoanId) {
      fetchLoanDetails();
    }
  }, [numericLoanId]);

  return (isLoading || isLoadingUser) ? (
    <CircularProgress variant="indeterminate" />
  ) : (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Manual Quote"
          handleClose={onClose}
          dialogContent={
            <ManualQuoteTab source={userStore.isNportalUser ? 'nportal' : 'cportal'} document={document} />
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Manual Quote"
          maxWidth="md"
          handleClose={onClose}
          dialogContent={
            <ManualQuoteTab source={userStore.isNportalUser ? 'nportal' : 'cportal'} document={document} />
          }
        />
      )}
    </>
  );
});
